import AdminManagementModule from './AdminManagementScreen.module.scss'
import { useState, useCallback } from 'react'
import LoadingGrid from '../LoadingGrid/LoadingGrid'
import { collection, doc, setDoc, updateDoc } from 'firebase/firestore'
import { db } from '../../firebase'
import StudentAnalysisPromptsComponent from './Items/StudentAnalysisPromptsComponent'
import { _system_settings } from '../../localConstant'
import AdminManagementScreenList from './AdminManagementScreenList'
import SubmissionAnalysisPromptsComponent from './Items/SubmissionAnalysisPromptsComponent'
import ModelsComponent from './Items/ModelsComponent'
function useEditedState(initialValue) {
  const [value, setValue] = useState(initialValue)
  const [isEdited, setIsEdited] = useState(false)
  const setEditedValue = useCallback((newValue) => {
    setValue(newValue)
  }, [])
  return [value, setEditedValue, isEdited, setIsEdited]
}

function ManagementScreen() {
  const [selectedItem, setSelectedItem, isEdited, setIsEdited] = useEditedState('')
  const [systemItems, setSystemItems] = useState(_system_settings)
  const [loading, setLoading] = useState(false)

  return (
    <>
      {loading ? (
        <LoadingGrid />
      ) : (
        <div className={AdminManagementModule.container}>
          <AdminManagementScreenList
            systemItems={systemItems}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            isEdited={isEdited}
            setIsEdited={setIsEdited}
          />
          <div className={AdminManagementModule.body}>
            {selectedItem.id === 'studentAnalysisPrompts' && <StudentAnalysisPromptsComponent />}
            {selectedItem.id === 'submissionAnalysisPrompts' && <SubmissionAnalysisPromptsComponent />}
            {selectedItem.id === 'models' && <ModelsComponent />}
          </div>
        </div>
      )}
    </>
  )
}
export default ManagementScreen
